import {EditorState} from "prosemirror-state";

export const getStartEndByPos = (state: EditorState, nodePos: number) => {
    const $resolvedPos = state.doc.resolve(nodePos)!;
    const markedText = state.doc.nodeAt(nodePos);

    const startPos = $resolvedPos.pos - $resolvedPos.nodeBefore!.nodeSize;
    const endPos = startPos + markedText?.nodeSize!
    return {
        startPos,
        endPos
    }
}